/* istanbul ignore file */
export * from './InspiringSearchTeaserWithAbTesting';
